import { render, staticRenderFns } from "./briefe.vue?vue&type=template&id=252762cb&scoped=true&"
import script from "./briefe.vue?vue&type=script&lang=js&"
export * from "./briefe.vue?vue&type=script&lang=js&"
import style0 from "./briefe.vue?vue&type=style&index=0&id=252762cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252762cb",
  null
  
)

export default component.exports